import "antd/dist/antd.css";
import "./App.css";
import { Routes, Route, NavLink, useLocation } from "react-router-dom";
import Home from "./Components/Home/index";
import About from "./Components/About/index";
import React, { useEffect, useState } from "react";
import Sider from "antd/lib/layout/Sider";
import Layout, { Content, Footer } from "antd/lib/layout/layout";
import { Menu } from "antd";

const menuItems = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" }
];

function App() {
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState("0");
  const [collapsed, setCollapsed] = useState(true);

  useEffect(() => {
    setSelectedKey(
      menuItems.findIndex(_item => location.pathname === _item.path).toString()
    );
  }, [location]);

  return (
    <Layout
      style={{
        minHeight: "100vh"
      }}
    >
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={value => setCollapsed(value)}
      >
        {/* <div className="logo" /> */}
        <Menu
          theme="dark"
          selectedKeys={[selectedKey]}
          mode="inline"
          // items={items}
        >
          {menuItems.map((item, index) => (
            <Menu.Item key={index}>
              <NavLink to={item.path}>
                <span>{item.label}</span>
              </NavLink>
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Content
          style={{
            margin: "0 16px"
          }}
        >
          <Routes>
            <Route exact path="" element={<Home />} />
            <Route exact path="/about" element={<About />} />
            <Route
              path="*"
              element={
                <main style={{ padding: "1rem" }}>
                  <p>There's nothing here!</p>
                </main>
              }
            />
          </Routes>
        </Content>
        <Footer
          style={{
            textAlign: "center"
          }}
        >
          Copyright &copy;{new Date().getFullYear()} hawa.inc All rights
          reserved
        </Footer>
      </Layout>
    </Layout>
  );
}

export default App;
